import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import AccountListModuleTypes from '@/store/modules/middleGround/member/accountList/interface';

const accountListModule: Module<AccountListModuleTypes, RootModuleTypes> = {
    namespaced:true,
    state: {

    },
    mutations: {

    },
    actions: {
        pageMemberList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/pageMemberList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listMemberRole(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/listMemberRole", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        deleteMember(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/deleteMember", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        checkMemberCodeUse(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/checkMemberCodeUse", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        saveOrUpdateMember(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/saveOrUpdateMember", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        updateLockStatus(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/updateLockStatus", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        updatePassword(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/updatePassword", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        
        
    },
};

export default accountListModule;